module.exports = __webpack_public_path__ + "static/media/block-img-four.d1e7f221.svg";